import React, { useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import {
  Text,
  CardPreview,
  CardHeader,
  CardFooter,
  Image,
} from '@fluentui/react-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { getAdPreviewStyles } from '../styles/ad-preview-styles';
import DEFAULT_PROFILE_IMAGE from '../media/default-profile-image.svg';

const MAX_TEXT_LENGTH = 50;

export const AdPreview = ({ adData, extraData }) => {
  const classes = useDefaultStyles(getAdPreviewStyles);
  const i18n = useContext(I18nContext);

  const companyPageName = _.get(extraData, 'Name');
  const userProfileImageSrc = _.get(extraData, 'LogoDownloadUrl') || DEFAULT_PROFILE_IMAGE;
  const finalUrl = _.get(adData, ['FinalUrls', '0']);
  const headline = _.get(adData, ['Headlines', 'Headline0']);
  let introductoryText = _.get(adData, ['Descriptions', 'Description0']);
  const imageList = _.get(adData, ['Images', 'ImageList'], []);
  const adImageUrl = imageList[0][0].src;

  if (introductoryText.length > MAX_TEXT_LENGTH) {
    introductoryText = `${introductoryText.substring(0, MAX_TEXT_LENGTH)}...`;
  }

  return (
    <div className={classes.placementContainer}>
      <CardHeader
        className={classes.placementCardHeader}
        image={<Image className={classes.placementLogo} src={userProfileImageSrc} alt={i18n.getString(_TL_('User profile image'))} />}
        header={<div className={classes.placementCompanyName}><b>{companyPageName}</b></div>}
        description={<Text className={classes.placementPromoteText}>{i18n.getString(_TL_('Promoted'))}</Text>}
      />

      <div className={classes.placementIntroductory}>
        <Text className={classes.placementIntroductoryText}>{introductoryText}</Text>
      </div>

      <CardPreview className={classes.placementCardPreview}>
        <Image src={adImageUrl} alt="ad image" />
      </CardPreview>

      <CardFooter className={classes.placementCardFooter}>
        <div className={classes.placementFooterText}>
          <Text className={classes.placementHeadline}>{headline}</Text>
          <Text className={classes.placementFinalUrl}>{finalUrl}</Text>
        </div>
      </CardFooter>
    </div>
  );
};

AdPreview.propTypes = {
  adData: PropTypes.shape({
    FinalUrls: PropTypes.arrayOf(PropTypes.string),
    Headlines: PropTypes.shape({
      Headline0: PropTypes.string,
    }),
    Descriptions: PropTypes.shape({
      Description0: PropTypes.string,
    }),
    Images: PropTypes.shape({
      ImageList: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
        src: PropTypes.string,
      }))),
    }),
  }).isRequired,
  extraData: PropTypes.shape({
    Name: PropTypes.string,
    LogoDownloadUrl: PropTypes.string,
  }).isRequired,
};
